import PropTypes from 'prop-types';

import { Box, Button, InputAdornment, TextField } from '@mui/material';

import { Add, SearchOutlined } from '@mui/icons-material';

import { createButtonSx, toolbarSx } from './styles';
import {
  searchFieldSx
} from '../Styles/InputStyles';

const ListingToolbar = ({
  search,
  searchPlaceholder,
  createLabel,
  onSearchChange,
  onCreate,
  children
}) => {
  return (
    <Box sx={toolbarSx}>
      <TextField
        size="small"
        value={search}
        placeholder={searchPlaceholder}
        onChange={event => onSearchChange(event.target.value)}
        sx={{ ...searchFieldSx, width: '25%' }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlined
                  sx={{
                    color: '#9E9E9E',
                    fontSize: 20
                  }}
                />
              </InputAdornment>
            )
          }
        }}
      />

      {children}

      <Box sx={{ flexGrow: 1 }} />

      <Button
        variant="outlined"
        startIcon={<Add />}
        onClick={onCreate}
        sx={createButtonSx}>
        {createLabel}
      </Button>
    </Box>
  );
};

ListingToolbar.propTypes = {
  search: PropTypes.string.isRequired,
  searchPlaceholder: PropTypes.string,
  createLabel: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  children: PropTypes.node
};

ListingToolbar.defaultProps = {
  searchPlaceholder: 'Search...',
  children: null
};

export default ListingToolbar;
